import { Component, OnInit } from '@angular/core';
import { HighlightService } from 'src/app/@core/services/highligh.service';

@Component({
  selector: 'app-barra-accesibilidad-doc',
  templateUrl: './barra-accesibilidad-doc.component.html',
  styleUrls: ['./barra-accesibilidad-doc.component.scss']
})
export class BarraAccesibilidadDocComponent implements OnInit {
  showComponent: boolean = true;
  utils: any;
  highlighted: boolean = false;
  codeHtml: string;
  codeJs: string;
  infoComponent: { titulo: string; descripcion: string; };
  constructor(
    private highlightService: HighlightService) {
    this.utils = window.utils;
    this.codeHtml = `
<div class="block block--gov-accessibility">
    <div class="block-options navbar-expanded">
        <a class="contrast-ref">
            <span class="govco-icon govco-icon-contrast-n"></span>
            <label> Contraste </label>
        </a>
        <a class="min-fontsize">
            <span class="govco-icon govco-icon-less-size-n"></span>
            <label class="align-middle"> Reducir letra </label>
        </a>
        <a class="max-fontsize">
            <span class="govco-icon govco-icon-more-size-n"></span>
            <label class="align-middle"> Aumentar letra </label>
        </a>
        <a target="_blank" href="https://centroderelevo.gov.co/632/w3-channel.html">
            <span class="govco-icon govco-icon-relief-n"></span>
            <label class="align-middle"> Centro de relevo </label>
        </a>
    </div>
</div>`;

    this.infoComponent = {
      titulo: "Barra de accesibilidad",
      descripcion: 
        "El componente barra de accesibilidad, hace parte de los componentes maestros del proyecto GOVCO."
    }
  }

  showAccesibilidad() {
    this.showComponent = !this.showComponent;
    if (this.showComponent) {
    }
  }
  ngAfterViewChecked() {
    if (!this.highlighted) {
      this.utils.initAccesibilidad();
      this.highlightService.highlightAll();
      this.highlighted = true;
    }
  }

  ngOnInit() {

  }

}
